import TSettingBusinessHoursEditHoursOnHolidayResponse from './index.vue';

TSettingBusinessHoursEditHoursOnHolidayResponse.install = app => {
  app.component(TSettingBusinessHoursEditHoursOnHolidayResponse.name, TSettingBusinessHoursEditHoursOnHolidayResponse);
};

export default TSettingBusinessHoursEditHoursOnHolidayResponse;
